// Référentiel des métiers COPPAM et leurs coefficients (extrait de SimulateurTarif).

export const METIERS_COPPAM = {
  gros_oeuvre: {
    label: "Gros Œuvre",
    couleur: "#0a3d62",
    metiers: {
      "Terrassement": { code: "GO_TERR", coefficient: 0.45 },
      "Maçonnerie générale": { code: "GO_MACO", coefficient: 0.48 },
      "Béton armé": { code: "GO_BETO", coefficient: 0.50 },
      "Construction de murs": { code: "GO_MURS", coefficient: 0.46 },
      "Charpente bois": { code: "GO_CHAR", coefficient: 0.44 },
      "Démolition": { code: "GO_DEMO", coefficient: 0.52 }
    }
  },
  second_oeuvre: {
    label: "Second Œuvre",
    couleur: "#DEA900",
    metiers: {
      "Électricité": { code: "SO_ELEC", coefficient: 0.40 },
      "Plomberie": { code: "SO_PLOM", coefficient: 0.42 },
      "Plâtrerie": { code: "SO_PLAT", coefficient: 0.38 },
      "Peinture": { code: "SO_PEIN", coefficient: 0.35 },
      "Menuiserie intérieure": { code: "SO_MENU", coefficient: 0.41 },
      "Carrelage": { code: "SO_CARR", coefficient: 0.39 }
    }
  },
  travaux_publics: {
    label: "Travaux Publics",
    couleur: "#b80000",
    metiers: {
      "Voirie": { code: "TP_VOIR", coefficient: 0.47 },
      "Assainissement": { code: "TP_ASSA", coefficient: 0.46 },
      "Réseaux": { code: "TP_RESE", coefficient: 0.45 }
    }
  },
  pib: {
    label: "PIB",
    couleur: "#2c5aa0",
    metiers: {
      "Architecte": { code: "PIB_ARCH", coefficient: 0.05 },
      "Bureau d'études": { code: "PIB_BE", coefficient: 0.06 },
      "Géomètre": { code: "PIB_GEOM", coefficient: 0.05 }
    }
  }
};
